import React from "react";
import { motion } from "framer-motion";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

function Insurance() {
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  const insuranceLogos = [
    "/assets/albaraka.png",
    "/assets/almash.png",
    "/assets/alwatania.webp",
    "/assets/golp.jpeg",
    "/assets/med.png",
    "/assets/nathealth.webp",
    "/assets/palstine.png",
    "/assets/wecare.webp",
  ];

  return (
    <div className="insurance py-5 mb-5 overflow-hidden" id="insurance" dir={isArabic ? "rtl" : "ltr"}>
      <Helmet>
        <title>{t("insurance.seoTitle")}</title>
        <meta name="description" content={t("insurance.seoDescription")} />
        <meta name="keywords" content={t("insurance.seoKeywords")} />
        <meta property="og:title" content={t("insurance.ogTitle")} />
        <meta property="og:description" content={t("insurance.ogDescription")} />
        <meta property="og:image" content={t("insurance.ogImage")} />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content={isArabic ? "ar_AR" : "en_US"} />
      </Helmet>

      {/* UI Content */}
      <div className="head text-center">
        <h2 className="mb-4 fs-1 fw-bolder" style={{ lineHeight: "1.8" }}>
          {t("insurance.title")}
        </h2>

        <div className="smile-container">
          <svg
            viewBox="0 0 200 100"
            xmlns="http://www.w3.org/2000/svg"
            style={{ width: "140px", marginTop: "-50px" }}
          >
            <defs>
              <linearGradient id="lineGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stopColor="#2BA3DF" />
                <stop offset="100%" stopColor="#6dd5ed" />
              </linearGradient>
            </defs>
            <path
              d="M10,40 Q50,90 190,30"
              stroke="url(#lineGradient)"
              strokeWidth="8"
              fill="none"
              strokeLinecap="round"
            />
          </svg>
        </div>
      </div>

      <div className="container mt-3">
        <p className="mt-3 text-muted">{t("insurance.paragraph")}</p>
        <div className="row justify-content-center align-items-center g-3">
          {insuranceLogos.map((logo, index) => (
            <motion.div
              key={index}
              className="col-6 col-md-3 text-center"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <img
                src={logo}
                alt={`Insurance ${index + 1}`}
                className="img-fluid p-2 rounded-4 shadow-sm w-75"
                loading="lazy"
                decoding="async"
                style={{ objectFit: "contain" }}
              />
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Insurance;
